import moment from 'moment'

/**
 * Returns true if the field contains the ARCHIBUS neutral value
 * @param fieldName The field name.
 * @returns {boolean}
 */
export const isNeutralValue = fieldName =>
  fieldName.lastIndexOf('.nl') === fieldName.length - 3

/**
 * Converts the string to the associated JavaScript object type using the FieldDef Java type.
 * @param value The string value to convert
 * @param type The Java type indicator
 * @returns {String|Date|number}
 */
export const convertValue = (value, type) => {
  let convertedValue = value
  switch (type) {
    case 'java.sql.Date':
      convertedValue = value
        ? moment(value, ['YYYY-MM-DD HH:mm:ss.S', 'YYYY-MM-DD']).toDate()
        : value
      break
    case 'java.sql.Time':
      convertedValue = value
        ? moment(value, ['YYYY-MM-DD HH:mm:ss.S', 'HH:mm:ss.S']).toDate()
        : value
      break
    case 'java.lang.Integer':
      convertedValue = value ? parseInt(value, 10) : value
      break
    case 'java.lang.Double':
      convertedValue = value ? parseFloat(value) : value
      break
    default:
  }

  return convertedValue
}

export const convertFieldName = (fieldName, tableNames) => {
  let name = fieldName
  // If the data source contains a single table then remove the table name from the field name
  if (tableNames.length === 1) {
    name = fieldName.replace(tableNames[0] + '.', '')
  } else {
    throw new Error('Conversion type is not found')
  }

  return name
}

export const getTotalNumberOfRecords = (dataSource, totals) => {
  let table = dataSource.tableNames[0]

  return parseInt(totals[`${table}.count_of_records`])
}
